import React, { createRef, useEffect, useRef, useState } from 'react'
import * as Sentry from '@sentry/react'
import { useNavigate } from 'react-router-dom'
import { useAtom } from 'jotai'
import { ray } from 'node-ray/web'

import { Button, IconButton, Loader, Timer, InputAutocomplete } from '../../components/transpais'
import Ticket from '../../components/transpais/TranspaisTicket'
import { BASE_URL, MAGIC_VALUE_ENABLED, MOCK_BOOKING_PAYMENT } from '../../utilities/constants'
import { isEmpty } from 'lodash'
import jwt_decode from "jwt-decode"
import { getTID, decodeToken, isValidTranspaisJwtShape } from '../../utilities/token'
import {
  isSingleTrip
} from '../../helpers/tripHelpers'
// import { decode } from '../../utilities/token'

import {
  accessToken,
  bookingSessionDepartureBlockedTickets,
  bookingSessionReturningBlockedTickets,
  bookingSessionDepartureTrip,
  bookingSessionDestination,
  bookingSessionOrigin,
  // bookingSessionTripId,
  bookingSessionTickets,
  bookingSessionPayments,
  pinpadPayment,
  bookingSessionTimeoutDeadline,
  usuarioID, bookingSessionReturningTrip, bookingSessionReset,
  bookingSessionTripConfig,
  bookingSessionDepartureTripId,
  bookingSessionReturningTripId,
  TranspaisIDToken,
  bookingSessionTrips,
  bookingSessionPassengers,
  settingsConfig,
  idleTimerPaused,
} from '../../utilities/atoms'
import { useModal } from '../../contexts/modal.context'
import { usePinpad } from '../../contexts/pinpad.context'

import '../../scss/Layout.scss'
import global from './BookingGlobal.module.scss'
import styles from './BookingReviewOrder.module.scss'
import { Helmet } from 'react-helmet'
import { genericErrorMessage } from '../../utilities/alerts'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { useLogger } from '../../contexts/logger.context'
// import { Breadcrumbs } from '@sentry/react'
import { currency } from '../../components/transpais/helpers/currency'
// import SaleTicket from './SaleTicket'
import Keyboard from 'react-simple-keyboard'
// import transpaisid from '../../services/transpaisid'
import transpais from '../../services/transpais'
import { getPinpadErrorMessage, ErrorSeverity } from '../../config/pinpad-v2/error-codes'
import { showPortsToPermission } from '../../helpers/showPortsToPermission'

// import { useBackListener } from '../../hooks/useBackListener'
import { useTimer } from '../../contexts/timer.context'
// import { formatInTimeZone } from 'date-fns-tz'
import { differenceInSeconds, parseISO } from 'date-fns'
import { handleApiError, reportError } from '../../helpers/errorHandler'
import { startBookingTimer, clearBookingTimer } from '../../helpers/bookingTimer'
import { handleBookingTimeout } from '../../helpers/bookingTimer'
import { formatDateForBooking } from '../../helpers/tripHelpers' // <-- agregado
import { bookingElectronPay } from './payment/bookingElectronPay'
import { buildMockConfirmResponse, mockCanPayResponse } from './payment/bookingPaymentMock'
import { recordFlightEvent } from '../../debug/flightRecorder'

/**
 * Prueba rápida: monto fijo manual (sobreescribe magic values si no es `null`).
 * `null` = totales reales, o montos por pasajero si `REACT_APP_MAGIC_VALUE_ENABLED=1`.
 */
const BOOKING_REVIEW_ORDER_TEST_CHARGE_AMOUNT = null

function passengerFullName (passenger) {
  if (!passenger || typeof passenger !== 'object') return ''
  const fromParts = `${passenger.firstName || ''} ${passenger.lastName || ''}`.trim()
  if (fromParts) return fromParts
  const singleName = String(passenger.name || passenger.fullName || '').trim()
  return singleName
}

function magicAmountForPassengerName (name) {
  const normalized = String(name || '').trim().toUpperCase()
  if (normalized === 'PRUEBA CIEN') return 100000
  if (normalized === 'PRUEBA CINCUENTA') return 50000
  return null
}

function resolveTestChargeAmount (departureTickets, returningTickets) {
  if (BOOKING_REVIEW_ORDER_TEST_CHARGE_AMOUNT != null) {
    return BOOKING_REVIEW_ORDER_TEST_CHARGE_AMOUNT
  }
  if (!MAGIC_VALUE_ENABLED) return null

  let magicAmount = null
  const considerPassenger = (passenger) => {
    const amount = magicAmountForPassengerName(passengerFullName(passenger))
    if (amount != null && (magicAmount == null || amount > magicAmount)) {
      magicAmount = amount
    }
  }

  for (const ticket of departureTickets || []) {
    if (Array.isArray(ticket?.passengers) && ticket.passengers.length > 0) {
      for (const passenger of ticket.passengers) {
        considerPassenger(passenger)
      }
    } else {
      considerPassenger(ticket)
    }
  }
  for (const passenger of returningTickets || []) {
    considerPassenger(passenger)
  }
  return magicAmount
}

/** Punto único para ajustar unidades (centavos vs pesos) cuando se confirme la regla real. */
function toPayAmount (total, testChargeAmount) {
  if (testChargeAmount != null) return testChargeAmount
  // TODO: ajustar según unidad real
  return total
}

/** Mensajes por `code` de Electron/IPC; el resto delega en getPinpadErrorMessage (no depender solo del string `message`). */
function resolvePaymentErrorForModal (code, fallbackMessage) {
  const c = String(code ?? 'UNKNOWN')
  switch (c) {
    case 'BRIDGE_TIMEOUT':
      return {
        code: c,
        userMessage: 'Tiempo de espera agotado en el pinpad',
        severity: ErrorSeverity.ERROR,
        retryable: true,
      }
    case 'PINPAD_NOT_READY':
      return {
        code: c,
        userMessage: 'Pinpad no listo, intenta nuevamente',
        severity: ErrorSeverity.ERROR,
        retryable: true,
      }
    case 'PINPAD_BUSY':
      return {
        code: c,
        userMessage: 'El pinpad está ocupado, intenta nuevamente',
        severity: ErrorSeverity.ERROR,
        retryable: true,
      }
    case 'BRIDGE_PAY_FAILED':
      return {
        code: c,
        userMessage:
          (fallbackMessage && String(fallbackMessage).trim() && !/^\d+$/.test(String(fallbackMessage).trim())
            ? String(fallbackMessage).trim()
            : null) ||
          'No se pudo completar el pago. Intenta nuevamente o usa otra tarjeta.',
        severity: ErrorSeverity.ERROR,
        retryable: true,
      }
    case 'TXN_NOT_APPROVED':
      return {
        code: c,
        userMessage:
          (fallbackMessage && String(fallbackMessage).trim()) ||
          'La transacción no fue aprobada',
        severity: ErrorSeverity.ERROR,
        retryable: true,
      }
    case 'SESSION_TOKEN_INVALID':
      return {
        code: c,
        userMessage: 'La sesión de invitado no es válida o expiró. Vuelve a iniciar sesión en el kiosko.',
        severity: ErrorSeverity.ERROR,
        retryable: false,
      }
    default:
      return getPinpadErrorMessage(c, fallbackMessage)
  }
}

const BookingReviewOrder = () => {

  const backReturn = useRef(false)
  const payInFlightRef = useRef(false)
  const paymentAttemptRef = useRef(0)
  const ticketsArea = useRef(null)
  const [localLoading, setLocalLoading] = useState(false)
  // Removed unused state: searchParam, search, filteredEmails

  const keyboard = useRef()
  const [keyboardLayout, setKeyboardLayout] = useState('default')

  const viajeIda = useRef(null)
  const viajeRegreso = useRef(null)
  // const currentUser = useRef(null)
  const timeDone = useRef(false)
  const didRunTimeoutRef = useRef(false)
  const sessionExpiredRef = useRef(false)
  const problemHandledRef = useRef(false) // evita mostrar múltiples modales por corrupción
  const cursorPosition = useRef(0)
  const enableCursor = useRef(false)
  const [showMails, setShowMails] = useState(false) // kept because actually used for UI toggle

  const [showScreenKeyboard, setShowScreenKeyboard] = useState(false)
  // const [email, setEmail] = useState('')
  const [to, setTo] = useState('')

  const [showScrollBottom, setShowScrollBottom] = useState(false)
  const [showScrollTop, setShowScrollTop] = useState(false)

  const [usuario,] = useAtom(usuarioID)
  const [bookingReset, setBookingReset] = useAtom(bookingSessionReset)
  const [bookingOrigin, setBookingOrigin] = useAtom(bookingSessionOrigin)
  const [bookingDestination,setBookingDestination] = useAtom(bookingSessionDestination)
  const [bookingDepartureTrip, setBookingDepartureTrip] = useAtom(bookingSessionDepartureTrip)
  const [bookingReturningTrip, setBookingReturningTrip] = useAtom(bookingSessionReturningTrip)
  const [, setPassengers] = useAtom(bookingSessionPassengers)
  // const [bookingTripId, setBookingTripId] = useAtom(bookingSessionTripId)
  const [bookingDepartureBlockedTickets, setBookingDepartureBlockedTickets] = useAtom(bookingSessionDepartureBlockedTickets)
  const [bookingReturningBlockedTickets, setBookingReturningBlockedTickets] = useAtom(bookingSessionReturningBlockedTickets)
  const [bookingTickets, setBookingTickets] = useAtom(bookingSessionTickets)
  const [bookingPayment, setBookingPayment] = useAtom(bookingSessionPayments)
  const [bookingTimeoutDeadline, setBookingTimeoutDeadline] = useAtom(bookingSessionTimeoutDeadline)
  const [bookingTripConfig, setBookingTripConfig] = useAtom(bookingSessionTripConfig)
  const [bookingDepartureTripId, setBookingDepartureTripId] = useAtom(bookingSessionDepartureTripId)
  const [bookingReturningTripId, setBookingReturningTripId] = useAtom(bookingSessionReturningTripId)
  const [transpaisIdToken,] = useAtom(TranspaisIDToken)
  const [session,] = useAtom(bookingSessionTrips)
  const [settings] = useAtom(settingsConfig)

  const [, setPayment] = useAtom(pinpadPayment)
  const [, setIdlePaused] = useAtom(idleTimerPaused)

  // ---------- Defensive normalization ----------
  // The atom may temporarily be null/[] depending on upstream flows or race conditions.
  // Normalize to a consistent object shape to avoid runtime crashes when drilling into nested props.
  const safeDeparture = (
    bookingDepartureBlockedTickets &&
    typeof bookingDepartureBlockedTickets === 'object' &&
    bookingDepartureBlockedTickets.items &&
    Array.isArray(bookingDepartureBlockedTickets.items.tickets)
  ) ? bookingDepartureBlockedTickets : {
    items: { tickets: [] },
    total: 0,
    displayTotal: 0,
    cartId: null,
  }

  const safeDepartureTickets = safeDeparture.items.tickets
  const safeReturning = Array.isArray(bookingReturningBlockedTickets) ? bookingReturningBlockedTickets : []
  const testChargeAmount = resolveTestChargeAmount(safeDepartureTickets, safeReturning)

  const navigate = useNavigate()
  // const {loading, processPurchase, checkPinpadReady, startWithCredentials, restartPinpad } = usePinpad()
  const {showModal, hideModal, setupModal} = useModal()
  const {loggerDebug, loggerWarn, loggerError} = useLogger()
  const {showTimer, setupTimer, hideTimer, waitingPayment} = useTimer()

  const adminPassRef = createRef()
  const [pinpadReconnecting, setPinpadReconnecting] = useState(false)
  const [sessionExpired, setSessionExpired] = useState(false)

  const isBookingDeadlinePassed = (deadline) => {
    if (!deadline || typeof deadline !== 'string') {
      return false
    }
    try {
      return differenceInSeconds(parseISO(deadline), new Date()) <= 0
    } catch {
      return false
    }
  }

  const markSessionExpired = ({ suppressTimeoutModal = false } = {}) => {
    sessionExpiredRef.current = true
    setSessionExpired(true)
    if (suppressTimeoutModal) {
      didRunTimeoutRef.current = true
    }
  }

  const shouldTreatSessionAsExpired = () => (
    sessionExpiredRef.current || isBookingDeadlinePassed(bookingTimeoutDeadline)
  )

  const closePaymentErrorModal = () => {
    hideModal()
    if (shouldTreatSessionAsExpired()) {
      markSessionExpired()
      navigate(`${ BASE_URL }/`)
    }
  }

  // Sin screensaver ni idle global de 5 min mientras el usuario está en review/pago.
  useEffect(() => {
    setIdlePaused(true)
    return () => {
      // Confirmed arma modo "done"; no reactivar idle global al desmontar review.
      if (!window.location.pathname.includes('/confirmed')) {
        setIdlePaused(false)
      }
    }
  }, [setIdlePaused])

  const isTimeoutError = (error) => {
    const code = String(error?.code || '')
    const message = String(error?.message || '')
    return code === 'TIMEOUT' || code === '408' || /timeout/i.test(message)
  }

  const handlePinpadReconnection = () => {
    setupModal({
      title: '⚠️ Pinpad no disponible',
      content: <>
        <p>Pinpad no disponible. Contacte al personal autorizado.</p>
        <p>Introduzca contraseña de administrador para reconectar:</p>
        <input className={ 'passInput' } type={ 'password' }
               ref={ adminPassRef }/>
        <div>
          <Keyboard
            onChange={ () => {} }
            onKeyPress={ (button) => {
              if (button === '{bksp}') {
                adminPassRef.current.value = adminPassRef.current.value.slice(0, -1)
              } else {
                adminPassRef.current.value += button
              }
            } }
            layout={ {
              default: [
                '1 2 3', '4 5 6', '7 8 9', ' 0 {bksp}',
              ]
            } }
            display={ {
              '{bksp}': `<svg class="key-icon"><use xlink:Href="#delete-left"/></svg>`,
            } }
          />
        </div>
      </>,
      actions: {
        positive: {
          title: 'Reconectar',
          onClick: async () => {
            if (adminPassRef.current.value !== process.env.REACT_APP_ADMIN_PASS) {
              hideModal()
              setupModal({
                title: 'Error',
                content: <p>Contraseña incorrecta.</p>,
                actions: {
                  positive: {
                    title: 'Cerrar',
                    onClick: () => hideModal(),
                  }
                }
              })
              showModal()
              return
            }

            hideModal()
            setPinpadReconnecting(true)

            try {
              await showPortsToPermission()

              // await startWithCredentials({
              //   name: '0005SIUA38',
              //   value: '5LV7H6BY0',
              // })

              setPinpadReconnecting(false)

              setupModal({
                title: '✅ Pinpad Reconectado',
                content: <p>El pinpad se ha reconectado correctamente. Ya puedes continuar con el pago.</p>,
                actions: {
                  positive: {
                    title: 'Continuar',
                    onClick: () => hideModal(),
                  }
                }
              })
              showModal()
            } catch (error) {
              if (isTimeoutError(error)) {
                try {
                  loggerWarn('Timeout en startWithCredentials, intentando restart + retry', {
                    code: error?.code,
                    message: error?.message,
                  })

                  // await restartPinpad()

                  // await startWithCredentials({
                  //   name: '0005SIUA38',
                  //   value: '5LV7H6BY0',
                  // })

                  setPinpadReconnecting(false)

                  setupModal({
                    title: '✅ Pinpad Reconectado',
                    content: <p>El pinpad se ha reconectado correctamente. Ya puedes continuar con el pago.</p>,
                    actions: {
                      positive: {
                        title: 'Continuar',
                        onClick: () => hideModal(),
                      }
                    }
                  })
                  showModal()
                  return
                } catch (retryError) {
                  setPinpadReconnecting(false)
                  loggerError('Error en reconexión de pinpad tras retry', {
                    code: retryError?.code,
                    message: retryError?.message,
                  })

                  setupModal({
                    title: '❌ Error de Reconexión',
                    content: <>
                      <p>No se pudo reconectar el pinpad.</p>
                      <p><strong>Código:</strong> {retryError?.code || 'UNKNOWN'}</p>
                      <p><strong>Mensaje:</strong> {retryError?.message || 'Error desconocido'}</p>
                    </>,
                    actions: {
                      positive: {
                        title: 'Cerrar',
                        onClick: () => hideModal(),
                      }
                    }
                  })
                  showModal()
                  return
                }
              }

              setPinpadReconnecting(false)
              loggerError('Error en reconexión de pinpad', {
                code: error?.code,
                message: error?.message,
              })

              setupModal({
                title: '❌ Error de Reconexión',
                content: <>
                  <p>No se pudo reconectar el pinpad.</p>
                  <p><strong>Código:</strong> {error?.code || 'UNKNOWN'}</p>
                  <p><strong>Mensaje:</strong> {error?.message || 'Error desconocido'}</p>
                </>,
                actions: {
                  positive: {
                    title: 'Cerrar',
                    onClick: () => hideModal(),
                  }
                }
              })
              showModal()
            }
          }
        },
        negative: {
          title: 'Cancelar',
          onClick: () => hideModal(),
        },
      }
    })
    showModal()
  }

  const completeMail = [
    'gmail.com',
    'outlook.com',
    'transpais.com.mx',
    'me.com',
    'hotmail.com',
    'icloud.com',
    'yahoo.com.mx',
    'live.com.mx',
    'yahoo.com',
    'hotmail.es',
    'live.com',
    'hotmail.com.mx',
    'prodigy.net.mx',
    'msn.com',
  ]

  const exit = () => {
    // legacy variable _bookingTicket removed (unused)
    navigate(`${ BASE_URL }/`)
  }

  const handleClick = (value) => {
    cursorPosition.current = value
    if(cursorPosition.current === to.length) {
      enableCursor.current = false
    } else {
      enableCursor.current = true
    }
  }
  function onKeyboardKeyPress(button) {
    loggerDebug('Button pressed', button)
    if (button === '{esc}') {
      setShowScreenKeyboard(false)
    } else if (button === '{bksp}') {
      if (enableCursor.current) {
        if (cursorPosition.current > 0) {
          setTo(to.slice(0, cursorPosition.current -1) + to.slice(cursorPosition.current))
          cursorPosition.current = cursorPosition.current - 1
        }
      }else{
        setTo(to.slice(0, -1))
      }
    } else if (button === '{shift}' || button === '{lock}') {
      handleShift()
    } else {
      setCodeKey(button)
    }

    //show/hidde select mails extensions
    if (button === '{at}') {
      setShowMails(true)
    }
  }

  const setCodeKey = (key) => {

    if (key !== 'Enter' && !(key.includes('{') && key.includes('}'))) {
      enableCursor.current ? setKeyPosition(key) : setTo(to + key)

      if (key === '@') {
        setShowMails(true)
      }

    } else if (key === '{at}' && to.indexOf('@') === -1) {
      enableCursor.current ? setKeyPosition('@') : setTo(to + '@')
      // setTo(to + '@')
    } else if (key === '{space}') {
      enableCursor.current ? setKeyPosition(' ') : setTo(to + ' ')
      // setTo(to + ' ')
    } else if (key === '{dotcom}') {
      enableCursor.current ? setKeyPosition('.com') : setTo(to + '.com')
      // setTo(to + '.com')
    }
  }

  function setKeyPosition (key) {
    if(key !== '@') {
      let addTo = to.substring(0, cursorPosition.current) + key + to.substring(cursorPosition.current)
      let increment = key === '.com' ? 4 : 1
      cursorPosition.current = cursorPosition.current + increment
      setTo(addTo)
    }
  }

  function handleShift() {
    //loggerDebug(keyboard.current)
    const newLayoutName = keyboardLayout === 'default' ? 'shift' : 'default'
    setKeyboardLayout(newLayoutName)
  }

  const getAdultPassengerName = (tickets) => {
    for (const ticket of tickets) {
      if (Array.isArray(ticket.passengers)) {
        const adultPassenger = ticket.passengers.find(passenger => passenger.fare === 'Adulto')
        if (adultPassenger) {
          return `${adultPassenger.firstName} ${adultPassenger.lastName}`
        }
      }
    }
    return ''
  }

  const willPay = async () => {
    // Electron es la fuente de verdad del cobro: no usamos readiness/reconnection del pinpad web.
    if (shouldTreatSessionAsExpired()) {
      markSessionExpired()
      return
    }

    if (!isEmpty(to)) {
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(to)) {
        setupModal({
          title: 'Atención',
          content: <>
            <p>El correo ingresado no es correcto, por favor verifícalo e inténtalo de nuevo.</p>
          </>,
        })
        showModal()
  
        return
      }
    } else {
      const decodedToken = jwt_decode(transpaisIdToken)
      console.log('decodedToken')
      console.log(decodedToken)
      setTo(decodedToken.email)
    }

    setShowScreenKeyboard(false)

    setupModal({
      title: 'Pago',
      content: <>
        <p>¿Deseas continuar con el pago de tus boletos?</p>
        { MOCK_BOOKING_PAYMENT ? (
          <p className={ styles.importantText }>
            Modo simulación: no se usará el pinpad ni confirmación real del API.
          </p>
        ) : (
          <p className={ styles.importantText }>Sigue las instrucciones en el lector de tarjeta</p>
        ) }
      </>,
      actions: {
        positive: {
          title: 'Pagar',
          onClick: async () => {
            if (payInFlightRef.current) return
            if (shouldTreatSessionAsExpired()) {
              markSessionExpired()
              hideModal()
              navigate(`${ BASE_URL }/`)
              return
            }
            payInFlightRef.current = true
            paymentAttemptRef.current += 1
            const attempt = paymentAttemptRef.current

            hideModal()
            waitingPayment(true)
            setLocalLoading(true)
            setIdlePaused(true)

            try {
              if (!isValidTranspaisJwtShape(transpaisIdToken)) {
                const sessionError = new Error('SESSION_TOKEN_INVALID')
                sessionError.code = 'SESSION_TOKEN_INVALID'
                throw sessionError
              }

              const startedAt = Date.now()
              if (MOCK_BOOKING_PAYMENT) {
                recordFlightEvent('PAYMENT:MOCK_START', { session }, 'BookingReviewOrder.pay')
              }
              const response = MOCK_BOOKING_PAYMENT
                ? mockCanPayResponse()
                : await transpais.canPay(session, transpaisIdToken)
              ray({ service: 'transpais.canPay', _response: response })

              if (response?.data?.error !== false) {
                throw new Error('canPay returned an error response')
              }

              const reference = `KV${ (bookingDepartureBlockedTickets?.cartId) ?? 'NA' }-${ Math.random().toString(36).slice(2, 6) }`
              const total = bookingDepartureBlockedTickets?.total ?? 0
              const chargeAmount = toPayAmount(total, testChargeAmount)

              console.log('[BOOKING][PAYMENT] start', {
                attempt,
                reference,
                total,
                amountSent: chargeAmount,
                session,
                ts: Date.now(),
              })

              const purchaseResult = await bookingElectronPay({
                reference,
                amount: chargeAmount,
                session,
                totalOriginal: chargeAmount,
              })

              console.log('[BOOKING][PAYMENT] result', {
                attempt,
                reference,
                success: purchaseResult?.success,
                elapsedMs: Date.now() - startedAt,
                ts: Date.now(),
              })

              const charge = purchaseResult?.charge
              const paymentResultOk =
                purchaseResult?.success === true &&
                charge &&
                typeof charge === 'object' &&
                String(charge?.reference ?? '') === String(reference) &&
                charge?.auth != null && String(charge.auth).trim() !== '' &&
                charge?.foliocpagos != null && String(charge.foliocpagos).trim() !== ''

              if (!paymentResultOk) {
                console.error('[KIOSKO][INVALID PAYMENT RESULT]', purchaseResult)
                const transactionError = new Error('Respuesta inválida del sistema de pago')
                transactionError.code = 'INVALID_PAYMENT_RESULT'
                throw transactionError
              }

              const approvedCharge = charge
              setPayment(approvedCharge)

              const card = {
                autorizacion: approvedCharge?.auth,
                folio: approvedCharge?.foliocpagos,
                correo: to,
                importe: approvedCharge?.amount,
                cliente: approvedCharge?.cc_name || getAdultPassengerName(safeDepartureTickets),
                operacion: approvedCharge?.foliocpagos,
                status: approvedCharge?.response,
                referencia: approvedCharge?.reference,
                tarjeta: approvedCharge?.cc_number,
                tipo: approvedCharge?.cc_type,
                marca: approvedCharge?.cc_type,
              }

              let tokenData
              let decodedToken
              try {
                tokenData = decodeToken(transpaisIdToken)
                decodedToken = jwt_decode(transpaisIdToken)
              } catch {
                const sessionError = new Error('SESSION_TOKEN_INVALID')
                sessionError.code = 'SESSION_TOKEN_INVALID'
                throw sessionError
              }

              const bodyData = {
                pin: getTID(transpaisIdToken),
                first_name: tokenData.nombre,
                last_name: tokenData.paterno,
                email: decodedToken.email,
                to,
                payments: [{
                  method: 'mit_santander',
                  amount: approvedCharge?.amount,
                  reference: approvedCharge?.reference,
                  card_type: approvedCharge?.cc_type,
                  authorization: approvedCharge?.auth,
                  card: {
                    name: card.cliente,
                    number: card.tarjeta,
                    type: card.tipo,
                    brand: card.tipo,
                  },
                }],
              }

              const confirmResponse = MOCK_BOOKING_PAYMENT
                ? buildMockConfirmResponse({
                  cart: bookingDepartureBlockedTickets,
                  returning: bookingReturningBlockedTickets,
                  charge: approvedCharge,
                  origin: bookingOrigin,
                  destination: bookingDestination,
                })
                : await transpais.confirm(session, bodyData, transpaisIdToken)
              if (MOCK_BOOKING_PAYMENT) {
                recordFlightEvent('PAYMENT:MOCK_CONFIRM_OK', {
                  tickets: confirmResponse?.data?.transactionSummary?.length ?? 0,
                }, 'BookingReviewOrder.pay')
              }
              const tripId = bookingTripConfig.redondo === true ? bookingReturningTripId : bookingDepartureTripId

              Sentry.setContext('Confirmation', {
                token: transpaisIdToken,
                tripId,
                usuario,
                card,
                email: decodedToken.email,
                to,
                tickets: bookingDepartureBlockedTickets,
                voucherPrinted: purchaseResult?.voucherPrinted,
                voucherPrintError: purchaseResult?.voucherPrintError,
              })

              const tickets = confirmResponse.data.transactionSummary.map(ticket => ({
                ...ticket,
                transactionNumber: confirmResponse.data.transactionNumber,
                beestudio: confirmResponse.data.beestudio,
              }))

              setBookingTickets(tickets)
              setBookingPayment(tickets)

              console.log('[KIOSKO][NAVIGATE CONFIRMATION]', {
                attempt,
                purchaseResult,
                confirmResponse: confirmResponse?.data,
              })

              if (purchaseResult?.voucherPrintError) {
                loggerWarn('Voucher no se imprimió pero la transacción fue aprobada', {
                  error: purchaseResult.voucherPrintError,
                  code: purchaseResult.voucherPrintErrorCode,
                })
              }

              waitingPayment(false)
              setLocalLoading(false)
            } catch (error) {
              if (error?.code === 'USER_CANCELLED') {
                console.log('[BOOKING][PAYMENT] user_cancelled', {
                  attempt,
                  code: error.code,
                  ts: Date.now(),
                })
                waitingPayment(false)
                setLocalLoading(false)
              } else {
                const hasCanPayErrorData = !!error?.response || !!error?.request
                const errorCode = String(error?.code || 'UNKNOWN')
                console.error('[BOOKING][PAYMENT] error', {
                  attempt,
                  code: errorCode,
                  message: error?.message,
                  ts: Date.now(),
                })
                const pinpadError = resolvePaymentErrorForModal(errorCode, error?.message)

                loggerError('Error en flujo de pago PinPad V2', {
                  code: errorCode,
                  message: error?.message,
                  pinpadError,
                })

                Sentry.setContext('Payment Error', {
                  code: errorCode,
                  message: error?.message,
                  reference: error?.reference,
                  amount: bookingDepartureBlockedTickets?.total,
                })
                Sentry.captureException(error)

                if (hasCanPayErrorData) {
                  const { userMessage, errorData } = handleApiError(error, {
                    session,
                    transpaisIdToken,
                    bookingDepartureBlockedTickets,
                  })
                  setupModal({
                    title: 'Error',
                    content: <p>{ userMessage }</p>,
                    actions: {
                      positive: {
                        title: 'Entendido',
                        onClick: closePaymentErrorModal,
                      },
                    },
                  })
                  showModal()
                  reportError(error, errorData)
                } else if (errorCode === 'SESSION_TOKEN_INVALID') {
                  setupModal(genericErrorMessage(<p>{ pinpadError.userMessage }</p>, () => {
                    hideModal()
                    navigate(`${ BASE_URL }/login`)
                  }))
                  showModal()
                } else {
                  setupModal(genericErrorMessage(<p>{ pinpadError.userMessage }</p>, () => {
                    console.log('[BOOKING][PAYMENT][ERROR_MODAL][CLOSE]', {
                      attempt,
                      code: errorCode,
                      ts: Date.now(),
                    })
                    closePaymentErrorModal()
                  }))
                  showModal()
                }

                waitingPayment(false)
                setLocalLoading(false)
              }
            } finally {
              if (isBookingDeadlinePassed(bookingTimeoutDeadline)) {
                markSessionExpired({ suppressTimeoutModal: true })
              }
              payInFlightRef.current = false
              console.log('[BOOKING][PAYMENT] done', {
                attempt,
                payInFlight: payInFlightRef.current,
                ts: Date.now(),
              })
            }
          }
        },
        negative: {
          title: 'No'
        }
      }
    })
    showModal()
  }

  const handleBack = () => {
    setBookingDepartureBlockedTickets({ items: { tickets: [] }, total: 0, displayTotal: 0, cartId: null })
    setBookingReturningBlockedTickets([])
  }

  const handleBackButtonClick = () => {
    const showBackModal = () => {
      setupModal({
        title: 'Atención',
        content: <p>Si regresas, perderás la configuración actual de tu viaje y tendrás que reconfigurarlo 😱. ¿Estás seguro de que deseas regresar? 🤔</p>,
        actions: {
          positive: {
            title: 'Continuar',
            onClick: () => {
              // Limpia timer antes de reiniciar flujo
              clearBookingTimer({
                hideTimer,
                setDeadline: setBookingTimeoutDeadline
              })
              handleBack()
              setBookingDepartureTrip(null)
              setBookingReturningTrip(null)
              setPassengers([])
              navigate(`${BASE_URL}/booking/search`)
              hideModal()
            }
          },
          negative: {
            title: 'Cancelar',
            onClick: () => {
              hideModal()
            }
          },
        }
      })
      showModal()
    }

    if (isSingleTrip(bookingTripConfig)) {
      showBackModal()
    } else {
      showBackModal()
    }
  }

  const onTimeout = () => {
    if (didRunTimeoutRef.current) return
    didRunTimeoutRef.current = true
    markSessionExpired()
    handleBookingTimeout({
      hideTimer,
      setDeadline: setBookingTimeoutDeadline,
      setupModal,
      showModal,
      navigate,
      message: '¡Lo sentimos! 😓 No podemos seguir reservando tus asientos porque más personas están intentando viajar. 🚌 Vuelve a iniciar tu compra cuando estés listo.',
      hideModal,
      beforeNavigate: () => {
        timeDone.current = true
        setLocalLoading(false)
      }
    })
  }

  //Unblock Seat When TimeOut

  useEffect(() => {
    const depCount = safeDepartureTickets.length
    const retCount = safeReturning.length

    const departureCorrupt = (
      !bookingDepartureBlockedTickets ||
      typeof bookingDepartureBlockedTickets !== 'object' ||
      !bookingDepartureBlockedTickets.items ||
      !Array.isArray(bookingDepartureBlockedTickets.items.tickets) ||
      bookingDepartureBlockedTickets.items.tickets.length === 0
    )

    if (!problemHandledRef.current && departureCorrupt && retCount === 0 && timeDone.current === false) {
      problemHandledRef.current = true
      try {
        Sentry.captureMessage('BookingReviewOrder departure cart corrupt', {
          level: 'error',
          extra: {
            hasObject: !!bookingDepartureBlockedTickets,
            ticketsArray: bookingDepartureBlockedTickets?.items?.tickets?.length,
          }
        })
      } catch (e) {
        console.error('[BookingReviewOrder] Error sending Sentry corruption event', e)
      }
      console.error('[BookingReviewOrder] Cart corrupt -> redirect to search')
      setBookingDepartureTrip(null)
      setBookingReturningTrip(null)
      setPassengers([])
      setBookingDepartureBlockedTickets({ items: { tickets: [] }, total: 0, displayTotal: 0, cartId: null })
      setBookingReturningBlockedTickets([])
      navigate(`${BASE_URL}/booking/search`, { state: { problem: 'cart-corrupt' }, replace: true })
      return
    }

    if (retCount === 0 && depCount === 0 && timeDone.current === true) {
      navigate(`${ BASE_URL }/`)
    }
  }, [safeDepartureTickets.length, safeReturning.length, bookingDepartureBlockedTickets, navigate, setBookingDepartureTrip, setBookingReturningTrip, setPassengers, setBookingDepartureBlockedTickets, setBookingReturningBlockedTickets])

  useEffect(() => {
    safeDepartureTickets.forEach((ticket, index) => {
      if (index === 0) {
        // viaje de ida
        viajeIda.current = formatDateForBooking(ticket?.date, ticket?.departureTime)
      } else if (index === 1) {
        // viaje de regreso (si aplica)
        viajeRegreso.current = formatDateForBooking(ticket?.date, ticket?.departureTime)
      }
    })
    console.log('otro', viajeIda.current, bookingReturningTrip, viajeRegreso.current)

    // Iniciar timer solo para viaje sencillo
    if (isSingleTrip(bookingTripConfig)) {
      startBookingTimer({
        settings,
        setupTimer,
        showTimer,
        setDeadline: setBookingTimeoutDeadline,
        onTimeout,
        source: 'review-order'
      })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bookingTripConfig])
  
  useEffect(() => {
    if (bookingTickets != null && bookingTickets.length !== 0
      && bookingPayment != null && bookingPayment.length !== 0) {
      loggerDebug('Confirmation', bookingTickets)
      loggerDebug('set false')
      setLocalLoading(false)
      clearBookingTimer({
        hideTimer,
        setDeadline: setBookingTimeoutDeadline
      })
      navigate(`${ BASE_URL }/booking/confirmed`)
    }
  }, [bookingTickets, bookingPayment])

  useEffect(() => {
    if (bookingReset) {
      navigate(`${ BASE_URL }/`)
    }
  }, [bookingReset])

  return (
    <>
      <Helmet>
      </Helmet>
      {/*----Page----*/ }
      { <Loader show={ localLoading }/> }
      <section className={ ['section-full', 'section-flex'].join(' ') }>
        <div className={ [global.top, styles.top].join(' ') }>
          <div className={ ['logo', styles.logo].join(' ') }>
            <figure className={ ['logo-image', 'logo-image-transpais-light'].join(' ') }/>
            <div className={ styles.timers }>
              <Timer variant={ 'clock' }/>
            </div>
            {/* <div className={ styles.toPay }>
              <FontAwesomeIcon
                icon={ solid('arrow-down') }
                bounce
                className={ styles.pointer }
              />
              <div className={ styles.pill }>
                <p>Selecciona los boletos que quieras pagar</p>
              </div>
            </div> */ }
          </div>
          <div className={ styles.middle }>
            <div className={ styles.details }>
              <div className={ styles.tickets } ref={ ticketsArea }>
                { /* Safe tickets extraction to avoid crash when structure is not ready */ }
                { safeDepartureTickets.map((ticket, i) => (
                  // console.log('ticket', ticket),
                  ticket.passengers.map((passenger, j) => {
                    // Mutate passenger safely (ensure object shape) then return Ticket
                    if (passenger && typeof passenger === 'object') {
                      passenger.from = ticket.from
                      passenger.to = ticket.to
                    }
                    return (
                      <Ticket key={ i + j } ticket={
                        testChargeAmount != null
                          ? { ...passenger, displayPassengerTotal: testChargeAmount }
                          : passenger
                      }
                              redondo={ bookingReturningBlockedTickets.length > 0 }
                              regreso={ false }
                              tripData={ {origin: ticket.from, destination: ticket.to} }
                              printable={ false }/>
                    )
                  })
                  // <Ticket key={ i } ticket={ ticket }
                  //             redondo={ bookingReturningBlockedTickets.length > 0 }
                  //             regreso={ false }
                  //             tripData={ {origin: ticket.from, destination: ticket.to} }
                  //             printable={ false }/>
                )) }
                { bookingReturningBlockedTickets.map((ticket, i) => (
                  <Ticket key={ i } ticket={
                    testChargeAmount != null
                      ? { ...ticket, displayPassengerTotal: testChargeAmount }
                      : ticket
                  }
                              redondo={ true }
                              regreso={ true }
                              tripData={ {origin: bookingDestination.name, destination: bookingOrigin.name} }
                              printable={ false }/>
                )) }
              </div>
              { showScrollTop && <div className={ styles.scrollTop }>
                <IconButton
                  type="neutral"
                  icon="chevron-up"
                  onClick={ () => {
                    ticketsArea.current.scrollBy({top: -300, behavior: 'smooth'})
                  } }
                />
              </div> }
              { showScrollBottom && <div className={ styles.scrollBottom }>
                <IconButton
                  type="neutral"
                  icon="chevron-down"
                  onClick={ () => {
                    ticketsArea.current.scrollBy({top: 300, behavior: 'smooth'})
                  } }
                />
              </div> }
            </div>
            <div className={ styles.resume }>
              <div className={ styles.card }>
                <div className={ styles.cols }>
                  <div className={ [styles.data, styles.half].join(' ') }>
                    <h2>Origen</h2>
                    <span className={ styles.value }>{ bookingOrigin.name }</span>
                  </div>
                  { bookingReturningBlockedTickets.length > 0 && <div className={ styles.redondo }>
                    <svg className={ [styles.icon].join(' ') }>
                      <use xlinkHref={ `#refresh` }/>
                    </svg>
                  </div> }
                  <div className={ [styles.data, styles.half].join(' ') }>
                    <h2>Destino</h2>
                    <span className={ styles.value }>{ bookingDestination.name }</span>
                  </div>
                </div>
                <div className={ styles.cols }>
                  <div className={ styles.data }>
                    <h2>Fecha y hora de viaje</h2>
                    { 
                      <span
                      className={ styles.value }>{ viajeIda.current !== null && viajeIda.current }{ viajeRegreso.current !== null &&
                      ' › ' + viajeRegreso.current
                    }</span>
                    }
                  </div>
                </div>
              </div>
              <div className={ styles.important }>
                <p>Tus boletos serán enviados al correo:</p>
                <div>
                  <InputAutocomplete onFocus={ (e) =>  setShowScreenKeyboard(e) } 
                    valueInput={ to } 
                    items={completeMail} 
                    trigger='@' 
                    onChange={(value) => setTo(value)}
                    handleClicked={handleClick}
                  />
                </div>
                
              </div>
              <div className={ [styles.card, styles.total].join(' ') }>
                <div>
                  <h2>Total a pagar</h2>
                  { <span
                    className={ styles.precio }>{ currency(
                      testChargeAmount != null
                        ? testChargeAmount
                        : (safeDeparture.displayTotal ?? 0),
                      0,
                    ) }</span> }
                  <p>Podrás realizar tu pago utilizando únicamente tu tarjeta de débito o crédito,
                    visa o
                    mastercard.</p>
                  <div className={ styles.cardsLogos }>
                    <img src={ require('../../assets/images/visa.svg').default } alt="VISA"/>
                    <img src={ require('../../assets/images/mastercard.svg').default }
                         alt="mastercard"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer className={ global.bottom }>
          <div>
            <Button onClick={handleBackButtonClick} type="neutral" left-icon="chevron-left">Volver</Button>
          </div>
          <div className={ global.middle }>
            <Button onClick={ () => {
              exit()
            } } type="positive" right-icon="house">Ir a inicio</Button>
          </div>
          <div>
            <Button
              onClick={ willPay }
              type="positive"
              right-icon="chevron-right"
              disabled={ sessionExpired || localLoading || pinpadReconnecting }
            >Pagar</Button>
          </div>
        </footer>
      </section>

      <div className={ [styles.keyboardWrapper, showScreenKeyboard ? styles.keyboardShown : null].join(' ') }>
        <Keyboard keyboardRef={ r => (keyboard.current = r) }
          //onChange={onKeyboardChange}
                  onKeyPress={ onKeyboardKeyPress }
                  layoutName={ keyboardLayout }
                  layout={ {
                    default: [
                      '{esc} 1 2 3 4 5 6 7 8 9 0 {bksp}',
                      '{blank} q w e r t y u i o p',
                      '{lock} a s d f g h j k l \u00f1 {blank}',
                      '{shift} z x c v b n m . - {shift}',
                      '{space} {at} {dotcom}',
                    ],
                    shift: [
                      '{esc} 1 2 3 4 5 6 7 8 9 0 {bksp}',
                      'Q W E R T Y U I O P \u0308',
                      '{lock} A S D F G H J K L \u00d1 {blank}',
                      '{shift} {blank} Z X C V B N M _ {shift}',
                      '{space} {at} {dotcom}',
                    ],
                  } }
                  display={ {
                    '{at}': `<svg class="key-icon"><use xlink:Href="#at"/></svg>`,
                    '{bksp}': `<svg class="key-icon"><use xlink:Href="#delete-left"/></svg>`,
                    '{esc}': `<svg class="key-icon"><use xlink:Href="#keyboard-down"/></svg>`,
                    '{blank}': ` `,
                    '{space}': ` `,
                    '{lock}': `<svg class="key-icon"><use xlink:Href="#font-case"/></svg>`,
                    '{shift}': `<svg class="key-icon"><use xlink:Href="#up"/></svg>`,
                    '{dotcom}': `.com`,
                  } }
        />
      </div>
    </>
  )
}

export default BookingReviewOrder
